export const mentorJobsConstants = {

  //apply jobs
  MENTOR_APPLY_JOB_ACTION_REQUEST: "MENTOR_APPLY_JOB_ACTION_REQUEST",
  MENTOR_APPLY_JOB_ACTION_SUCCESS: "MENTOR_APPLY_JOB_ACTION_SUCCESS",
  MENTOR_APPLY_JOB_ACTION_FAILURE: "MENTOR_APPLY_JOB_ACTION_FAILURE",

  //applied job list
  GET_MENTOR_APPLIED_JOBS_LIST_ACTION_REQUEST:
    "GET_MENTOR_APPLIED_JOBS_LIST_ACTION_REQUEST",
  GET_MENTOR_APPLIED_JOBS_LIST_ACTION_SUCCESS:
    "GET_MENTOR_APPLIED_JOBS_LIST_ACTION_SUCCESS",
  GET_MENTOR_APPLIED_JOBS_LIST_ACTION_FAILURE:
    "GET_MENTOR_APPLIED_JOBS_LIST_ACTION_FAILURE",

  //applied job details
  GET_MENTOR_APPLIED_JOB_DETAILS_ACTION_REQUEST:
    "GET_MENTOR_APPLIED_JOB_DETAILS_ACTION_REQUEST",
  GET_MENTOR_APPLIED_JOB_DETAILS_ACTION_SUCCESS:
    "GET_MENTOR_APPLIED_JOB_DETAILS_ACTION_SUCCESS",
  GET_MENTOR_APPLIED_JOB_DETAILS_ACTION_FAILURE:
    "GET_MENTOR_APPLIED_JOB_DETAILS_ACTION_FAILURE",

};
